const general = {
  all: 'All',
  apply: 'Apply',
  category: 'Category',
  categories: 'Categories',
  custom: 'Custom',
  doors: 'Doors',
  resetDate: 'Reset date',
  resetFilters: 'Reset filters',
  users: 'Users',
  legend: 'Legend',
  export: 'Export',
  export_all: 'Export all',
  organizations: 'Accounts',
  download_started: 'Download started',
  delay: 'Delay',
  entry_reader: 'Entry reader',
  exit_reader: 'Exit reader',
  door: 'Door',
  schedule: 'Schedule',
  user: 'User',
  new_user: 'New user',
  account: 'Account',
  unassign: 'Unassign',
  assigned: 'Assigned',
  unassigned: 'Unassigned',
  unused_since: 'Unused since',
  unused_since_options: {
    any: 'Any',
    last_month: 'Last month',
    last_3_months: '3 months',
    last_6_months: '6 months',
    never: 'Never',
  },
  clear: 'Clear',
  access_levels: 'Access levels',
  activation: 'Activation',
  expiration: 'Expiration',
  credentials: 'Credentials',
  new_credential: 'New credential',
  dataLoadingFailed: 'Something went wrong while loading data.',
  role: 'Role',
  roles: 'Roles',
  failed: 'Failed',
  inputs: 'Inputs',
  keypad_code: 'Keypad code',
  not_assigned: 'Not assigned',
  pending: 'Pending',
  ping: 'Ping',
  contactYourDealer: 'Contact your dealer',
  controller: 'Controller',
  date_and_time: 'Date and time',
  description: 'Description',
  details: 'Details',
  name: 'Name',
  object_type: 'Object type',
  site: 'Site',
  sites_assigned: 'Sites assigned',
  active: 'Active',
  inactive: 'Inactive',
  deactivate: 'Deactivate',
  yes: 'Yes',
  no: 'No',
  boolean_none: 'None',
  boolean_false: 'False',
  boolean_true: 'True',
  day: 'Day',
  hour: 'Hour',
  minute: 'Minute',
  the: 'The',
  yearly: 'Yearly',
  on: 'On',
  and: 'And',
  welcome: 'Welcome',
  online: 'Online',
  offline: 'Offline',
  all_sites: 'All sites',
  access_all_accounts: 'Access all accounts, including new ones',
  refresh: 'Refresh',
  success: 'Success',
  error: 'Error',
  kprog_error: 'Kprog Error',
  delete_message: 'Are you sure you want to delete',
  are_you_sure: 'Are you sure?',
  replacing: 'Replacing',
  rebooting: 'Rebooting',
  from: 'From',
  to: 'To',
  to_label: 'to',
  status_label: 'Status:',
  general: 'General',
  confirmation: 'Confirmation',
  filters: 'Filters',
  search: 'Search',
  results: 'Results',
  loading: 'Loading',
  loading_ellipsis: 'Loading...',
  reason: 'Reason',
  alerts: 'Alerts',
  multisite: 'Multisite',
  comments: 'Comments',
  leave_message:
    'Are you sure you want to leave? Any unsaved changes will be lost.',
  quantity: 'Quantity',
  status: 'Status',
  summary: 'Summary',
  general_information: 'General Information',
  activate: 'Activate',
  events: 'Events',
  save: 'Save',
  enabled: 'Enabled',
  today: 'Today',
  yesterday: 'Yesterday',
  launch: 'Launch',
  enable: 'Enable',
  finished: 'Finished',
  settings: 'Settings',
  more_filters: 'More filters',
  radio_options: 'Radio Options',
  invalid_date: 'Invalid date',
  field_required: 'This field is required',
  date_after: 'Date must be on or after {{date}}',
  date_before: 'Date must be on or before {{date}}',
  date_from_before_to: 'From-date must be before to-date',
  date_to_after_from: 'To-date must be after from-date',
  date_from_too_late: 'Must be before or equal to the end date',
  date_to_too_early: 'Must be after or equal to the start date',
  file_too_big: 'File size is too big! Please select a file smaller than 1 MB',
  state: 'State',
  back_to_list: 'Back to list',
  company: 'Company',
  country: 'Country',
  city: 'City',
  phone: 'Phone',
  address: 'Address',
  none: 'None',
  no_image: 'No image',
  unknown: 'Unknown',
  object: 'Object',
  type: 'Type',
  id: 'ID',
  display_name: 'Display name',
  serial_number: 'Serial number',
  format: 'Format',
  formats: 'Formats',
  site_name: 'Site Name',
  replace: 'Replace',
  cancel: 'Cancel',
  close: 'Close',
  profile: 'Profile',
  province_territory: 'Province or Territory',
  zip_code: 'Zip Code',
  postal_code: 'Postal Code',
  email: 'Email',
  first_name: 'First Name',
  last_name: 'Last Name',
  full_name: 'Full Name',
  start: 'Start',
  stop: 'Stop',
  purchase: 'Purchase',
  date: 'Date',
  title: 'Title',
  event: 'Event',
  btn: {
    buy: 'Buy',
    discontinue: 'Discontinue',
    continue: 'Continue',
    back: 'Back',
    open: 'Open',
    select: 'Select',
    view: 'View',
    delete: 'Delete',
    update: 'Update',
    edit: 'Edit',
    submit: 'Submit',
    confirm: 'Confirm',
    next: 'Next',
    previous: 'Previous',
    checkout: 'Checkout',
    add_card: 'Add credential',
    dismiss: 'Dismiss',
    enable: 'Enable',
    disable: 'Disable',
    enable_access: 'Enable access',
    disable_access: 'Disable access',
    done: 'Done',
    remove: 'Remove',
    reset: 'Reset to Normal State',
    lock: 'Lock (override)',
    unlock: 'Unlock (override)',
    grant_access: 'Grant access',
    grant_extend: 'Extended Access',
    actions: 'Actions',
    disabled: 'Disabled',
    register: 'Register',
    refresh: 'Refresh',
    restore: 'Restore',
    send: 'Send',
    test: 'Test',
    list_view: 'List View',
    chart_view: 'Chart View',
    default: 'Default',
    go_back: 'Go back',
    now: 'Now',
    later: 'Later',
    resend: 'Resend',
    add: 'Add',
    ok: 'OK',
    apply: 'Apply',
  },
  form: {
    timezone: 'Timezone',
  },
  month: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
  day_name: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
  },
  cardinal: {
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    last: 'Last',
  },
  aria_expand_row: 'Expand row',
  aria_breadcrumb: 'Breadcrumb',
  aria_choices: 'Choices',
  aria_options: 'Options',
  options_label: 'Options',
  options_label_2: 'Options 2',
  checkbox_options_label: 'Checkbox options',
  status_ok: 'Status: OK',
  error_fallback_title: 'Oops! Something went wrong.',
  error_fallback_message:
    'The issue has been reported to our development team and will be resolved as soon as possible. Thank you for your patience.',
  event_id: 'Event ID',
  error_selecting_image: 'Error selecting image file',
  date_filter: {
    all: 'All',
    this_week: 'This Week',
    last_week: 'Last Week',
    this_month: 'This Month',
    last_month: 'Last Month',
    this_year: 'This Year',
    last_7_days: 'Last 7 Days',
    last_30_days: 'Last 30 Days',
    last_60_days: 'Last 60 Days',
    last_90_days: 'Last 90 Days',
    last_180_days: 'Last 180 Days',
    custom: 'Custom',
    range: 'From {{ from }} to {{ to }}',
    from: 'From {{ from }}',
    to: 'To {{ to }}',
  },
};

export default general;
